import React from 'react';
import DashBoardVar from './DashBoardVar/DashBoardVar';

const DashBoard = () => {
    return (
        <div className='container-lg rounded my-1'>
            <DashBoardVar></DashBoardVar>
        </div>
    );
};

export default DashBoard;